import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,LoadingController,Events } from 'ionic-angular';
import { AuthProvider } from '../../providers/auth/auth';

/**
 * Generated class for the FaqPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-faq',
  templateUrl: 'faq.html',
})
export class FaqPage {
  
  loader:any;
  faqs = [];

  constructor(public navCtrl: NavController, public navParams: NavParams, public loadingCtrl: LoadingController,  public events:Events,
    private authProvider: AuthProvider
  ) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad FaqPage');

   
  }

  async ionViewWillEnter(){
    this.authProvider.showLogoutButtonFn(true)

   this.showLoading();
  



  this.events.subscribe('help:faqContent', (faqs) => {
       
        faqs.sort(function(a,b) {
         if (a.id < b.id ) {
            return -1;
          }
          if (a.id > b.id) {
            return 1;
          }
          return 0;
       });

       this.faqs = faqs;
       this.hideLoading();
     });

   this.events.publish('help:getFaqs');

  }

  ionViewWillLeave(){
    this.authProvider.showLogoutButtonFn(false)
  }

  showLoading(){

      this.loader =  this.loadingCtrl.create({
            content: "Please Wait",
            duration: 100000
      });

      this.loader.present();
  }

  hideLoading(){
      if(this.loader){
           this.loader.dismiss();
      }
  }

  toggleAccordion(item: any) {
    this.faqs.forEach((accordionItem) => {
      if (accordionItem !== item) {
        accordionItem.expanded = false;
      }
    });
    item.expanded = !item.expanded;
  }

}



// WEBPACK FOOTER //
// ./src/pages/faq/faq.ts